<div style="display:flex; flex-direction:row">
    <div style="flex: 1">
        <h2>Update This Rate</h2>
        <form [formGroup]="new_rate_form" class="rate-form">
            <div *ngIf="new_rate_form.errors?.['startDateAfterEndDate']">
                Start date must be before the end date.
            </div>
            <div *ngIf="new_rate_form.get('new_rate')?.hasError('required') || new_rate_form.get('new_rate')?.untouched">
                Rate required
            </div>
            <div *ngIf="submissionStatus !== null">
                <span *ngIf="submissionStatus" style="color:green">Update successful!</span>
                <span *ngIf="!submissionStatus" style="color:red">Update failed</span>
            </div>
            <mat-form-field>
                <mat-label>New Rate</mat-label>
                <input matInput formControlName="new_rate" type="number">
            </mat-form-field>
            <mat-form-field *ngIf="gridType === 'customer-rates'">
                <mat-label>New Minimum Rate</mat-label>
                <input matInput formControlName="min_rate" type="number">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="start_datepicker" formControlName="start_date"/>
                <mat-datepicker-toggle matIconSuffix [for]="start_datepicker"></mat-datepicker-toggle>
                <mat-datepicker #start_datepicker>
                    <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>Cancel</button>
                        <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                    </mat-datepicker-actions>              
                </mat-datepicker>
            </mat-form-field>
            <mat-form-field>
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="end_datepicker" formControlName="end_date"/>
                <mat-datepicker-toggle matIconSuffix [for]="end_datepicker"></mat-datepicker-toggle>
                <mat-datepicker #end_datepicker>
                    <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>Cancel</button>
                        <button mat-raised-button color="primary" matDatepickerApply>Confirm</button>
                    </mat-datepicker-actions>              
                </mat-datepicker>
            </mat-form-field>
            <div>
                <button mat-raised-button (click)="submitNewRate()">Submit</button>
                <button mat-raised-button (click)="clearForm()">Clear</button>
            </div>
        </form>
    </div>
    <div style="flex: 3">
        Map goes here
    </div>
</div>
